// extracted by mini-css-extract-plugin
export var bodySections = "_cu-8";
export var gray = "_cu-7";
export var green = "_cu-4";
export var iconContainer = "_cu-9";
export var iconWidgetContainer = "_cu-1";
export var phoneIcon = "_cu-2";
export var red = "_cu-5";
export var statusDot = "_cu-3";
export var widgetContainer = "_cu-0";
export var yellow = "_cu-6";